export const LOAD_SIDEBAR_LIST = 'APP/SIDEBAR/LOAD_LIST'
export const LOAD_SIDEBAR_LIST_SUCCESS =
  'APP/SIDEBAR/LOAD_LIST_SUCCESS'
export const LOAD_SIDEBAR_LIST_ERROR = 'APP/SIDEBAR/LOAD_LIST_ERROR'

export const CLEAN_UP = 'APP/SIDEBAR/CLEAN_UP'
